import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CloseIcon from 'Components/icons/CloseIcon';
import PrimaryButton from 'Components/Button/PrimaryButton';

import counterpart from 'counterpart';

import './OnboardingTooltip.scss';

const OnboardingTooltip = ({ closeTooltip, tooltipText, extraClass, clickHandler, showButton, showCloseIcon }) => {
  const wrapperClass = classnames('onboardingTooltip', {
    [extraClass]: extraClass,
  });
  const topicTextArray = formatTopicText(tooltipText);

  return (
    <div className={wrapperClass} >
      {showCloseIcon && !showButton && topicTextArray[0] && <div onClick={closeTooltip} className="closeIcon"><CloseIcon type="tooltip" /></div>}
      {showCloseIcon && !showButton && !topicTextArray[0] && <div onClick={closeTooltip} className="closeIconNoTitle"><CloseIcon type="tooltip" /></div>}
      <div><h3 className="tooltipTitle">{topicTextArray[0]}</h3></div>
      {topicTextArray[1]}
      {topicTextArray[2] && <hr className="horizintalLine" />}
      {topicTextArray[2]}
      {showButton &&
      <div>
        <hr className="horizintalLine" />
        <br />
        <PrimaryButton
          action={closeTooltip}
          extraClass="gd-filter-pane__apply-button"
        >{counterpart('globalTranslate.common.okay')}
        </PrimaryButton>
      </div>
        }
    </div>
  );

  function formatTopicText(topicText) {
    return String(topicText).split('\\n');
  }
};


OnboardingTooltip.propTypes = {
  tooltipText: PropTypes.string,
  extraClass: PropTypes.string,
  closeTooltip: PropTypes.func,
  clickHandler: PropTypes.func,
  showButton: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
};

OnboardingTooltip.defaultProps = {
  tooltipText: '',
  extraClass: '',
  showButton: false,
  showCloseIcon: true,
  clickHandler: () => { },
};

export default OnboardingTooltip;
